import { render, staticRenderFns } from "./DetalhesFaseContrato.vue?vue&type=template&id=737acb8b&"
import script from "./DetalhesFaseContrato.vue?vue&type=script&lang=js&"
export * from "./DetalhesFaseContrato.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports